<slotcom-legal-layout [modalName]="NonPersistedModalName.CookiesComponent">
  <div class="e-title">{{ 'legal.cookies.title' | translate | uppercase }}</div>
  <p [innerHTML]="'legal.cookies.p-1' | translate"></p>
  <p [innerHTML]="'legal.cookies.p-2' | translate"></p>

  <div class="e-cookiesButton">
    <slotcom-button
      class="c-button--pink"
      (click)="openCookiesConfig()"
      audioType="functionality">
      {{ 'home.buttons.configure' | translate | uppercase }}
    </slotcom-button>
  </div>

  <!-- 1. ¿Qué es una cookie? -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.cookies.what-is-cookie.title' | translate"></div>
  <p [innerHTML]="'legal.cookies.what-is-cookie.p-1' | translate"></p>
  <p [innerHTML]="'legal.cookies.what-is-cookie.p-2' | translate"></p>

  <!-- 2. ¿Qué tipo de cookies utilizamos? -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.cookies.kind-cookies-using.title' | translate"></div>
  <p [innerHTML]="'legal.cookies.kind-cookies-using.p-1' | translate"></p>

  <table>
    <tr>
      <th
        colspan="2"
        [innerHTML]="'legal.cookies.kind-cookies-using.table.tr-1.th-1' | translate"></th>
    </tr>
    <tr>
      <td [innerHTML]="'legal.cookies.kind-cookies-using.table.tr-2.td-1' | translate"></td>
      <td>
        <p [innerHTML]="'legal.cookies.kind-cookies-using.table.tr-2.td-2' | translate"></p>
      </td>
    </tr>
    <tr>
      <td [innerHTML]="'legal.cookies.kind-cookies-using.table.tr-3.td-1' | translate"></td>
      <td>
        <p [innerHTML]="'legal.cookies.kind-cookies-using.table.tr-3.td-2.p-1' | translate"></p>
        <p [innerHTML]="'legal.cookies.kind-cookies-using.table.tr-3.td-2.p-2' | translate"></p>
      </td>
    </tr>
    <tr>
      <th
        colspan="2"
        [innerHTML]="'legal.cookies.kind-cookies-using.table.tr-4.th-1' | translate"></th>
    </tr>
    <tr>
      <td [innerHTML]="'legal.cookies.kind-cookies-using.table.tr-5.td-1' | translate"></td>
      <td>
        <p [innerHTML]="'legal.cookies.kind-cookies-using.table.tr-5.td-2' | translate"></p>
      </td>
    </tr>
    <tr>
      <td [innerHTML]="'legal.cookies.kind-cookies-using.table.tr-6.td-1' | translate"></td>
      <td>
        <p [innerHTML]="'legal.cookies.kind-cookies-using.table.tr-6.td-2' | translate"></p>
      </td>
    </tr>
    <tr>
      <th
        colspan="2"
        [innerHTML]="'legal.cookies.kind-cookies-using.table.tr-7.th-1' | translate"></th>
    </tr>
    <tr>
      <td [innerHTML]="'legal.cookies.kind-cookies-using.table.tr-8.td-1' | translate"></td>
      <td>
        <p [innerHTML]="'legal.cookies.kind-cookies-using.table.tr-8.td-2' | translate"></p>
      </td>
    </tr>
    <tr>
      <td [innerHTML]="'legal.cookies.kind-cookies-using.table.tr-9.td-1' | translate"></td>
      <td>
        <p [innerHTML]="'legal.cookies.kind-cookies-using.table.tr-9.td-2' | translate"></p>
      </td>
    </tr>
  </table>

  <!-- 3. ¿Qué cookies podrá encontrar en nuestro sitio web? -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.cookies.cookies-can-you-find.title' | translate"></div>
  <p [innerHTML]="'legal.cookies.cookies-can-you-find.p-1' | translate"></p>

  <div class="h-doubleColumn">
    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>

    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-2.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-2.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-2.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-2.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-2.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-2.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-2.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-2.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-2.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-2.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>
  </div>

  <div class="h-doubleColumn">
    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-3.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-3.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-3.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-3.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-3.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-3.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-3.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-3.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-3.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-3.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>

    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-4.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-4.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-4.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-4.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-4.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-4.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-4.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-4.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-4.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-4.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>
  </div>

  <div class="h-doubleColumn">
    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-5.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-5.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-5.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-5.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-5.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-5.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-5.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-5.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-5.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-5.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>

    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-6.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-6.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-6.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-6.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-6.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-6.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-6.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-6.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-6.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-6.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>
  </div>

  <div class="h-doubleColumn">
    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-7.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-7.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-7.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-7.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-7.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-7.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-7.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-7.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-7.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-7.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>

    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-8.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-8.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-8.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-8.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-8.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-8.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-8.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-8.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-8.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-8.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>
  </div>

  <div class="h-doubleColumn">
    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-9.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-9.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-9.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-9.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-9.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-9.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-9.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-9.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-9.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-9.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>

    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-10.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-10.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-10.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-10.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-10.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-10.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-10.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-10.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-10.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-10.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>
  </div>

  <div class="h-doubleColumn">
    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-11.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-11.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-11.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-11.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-11.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-11.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-11.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-11.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-11.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-11.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>

    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-12.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-12.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-12.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-12.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-12.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-12.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-12.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-12.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-12.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-12.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>
  </div>

  <div class="h-doubleColumn">
    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-13.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-13.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-13.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-13.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-13.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-13.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-13.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-13.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-13.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-13.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>

    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-14.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-14.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-14.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-14.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-14.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-14.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-14.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-14.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-14.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-14.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>
  </div>

  <div class="h-doubleColumn">
    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-15.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-15.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-15.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-15.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-15.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-15.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-15.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-15.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-15.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-15.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>

    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-16.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-16.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-16.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-16.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-16.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-16.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-16.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-16.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-16.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-16.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>
  </div>

  <div class="h-doubleColumn">
    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-17.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-17.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-17.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-17.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-17.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-17.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-17.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-17.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-17.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-17.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>

    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-18.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-18.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-18.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-18.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-18.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-18.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-18.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-18.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-18.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-18.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>
  </div>

  <div class="h-doubleColumn">
    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-19.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-19.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-19.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-19.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-19.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-19.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-19.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-19.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-19.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-19.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>

    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-20.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-20.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-20.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-20.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-20.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-20.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-20.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-20.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-20.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-20.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>
  </div>

  <div class="h-doubleColumn">
    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-21.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-21.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-21.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-21.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-21.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-21.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-21.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-21.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-21.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-21.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>

    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-22.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-22.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-22.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-22.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-22.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-22.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-22.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-22.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-22.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-22.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>
  </div>

  <div class="h-doubleColumn">
    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-23.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-23.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-23.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-23.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-23.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-23.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-23.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-23.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-23.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-23.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>

    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-24.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-24.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-24.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-24.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-24.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-24.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-24.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-24.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-24.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-24.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>
  </div>

  <div class="h-doubleColumn">
    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-25.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-25.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-25.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-25.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-25.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-25.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-25.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-25.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-25.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-25.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>

    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-26.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-26.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-26.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-26.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-26.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-26.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-26.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-26.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-26.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-26.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>
  </div>

  <div class="h-doubleColumn">
    <table>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-27.tr-1.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-27.tr-1.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-27.tr-2.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-27.tr-2.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-27.tr-3.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-27.tr-3.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-27.tr-4.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-27.tr-4.td-2' | translate"></p>
        </td>
      </tr>
      <tr>
        <td [innerHTML]="'legal.cookies.cookies-can-you-find.table-27.tr-5.td-1' | translate"></td>
        <td>
          <p [innerHTML]="'legal.cookies.cookies-can-you-find.table-27.tr-5.td-2' | translate"></p>
        </td>
      </tr>
    </table>
  </div>

  <!-- 4. ¿Cómo deshabilitar y bloquear cookies? -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.cookies.how-disable-cookies.title' | translate"></div>
  <p [innerHTML]="'legal.cookies.how-disable-cookies.p-1' | translate"></p>
  <p [innerHTML]="'legal.cookies.how-disable-cookies.p-2' | translate"></p>
  <p [innerHTML]="'legal.cookies.how-disable-cookies.p-3' | translate"></p>
  <ul>
    <li [innerHTML]="'legal.cookies.how-disable-cookies.list.l-1' | translate"></li>
    <li [innerHTML]="'legal.cookies.how-disable-cookies.list.l-2' | translate"></li>
    <li [innerHTML]="'legal.cookies.how-disable-cookies.list.l-3' | translate"></li>
    <li [innerHTML]="'legal.cookies.how-disable-cookies.list.l-4' | translate"></li>
  </ul>

  <!-- 5. Cambios en la política de cookies -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.cookies.changes-in-policy.title' | translate"></div>
  <p [innerHTML]="'legal.cookies.changes-in-policy.p-1' | translate"></p>

  <!-- 6. Contacto -->
  <div
    class="e-subtitle"
    [innerHTML]="'legal.cookies.contact.title' | translate"></div>
  <p [innerHTML]="'legal.cookies.contact.p-1' | translate"></p>

  <!-- Última version -->
  <p
    class="e-lastVersion"
    [innerHTML]="'legal.cookies.last-version.p-1' | translate"></p>
</slotcom-legal-layout>
